<template>
  <Flex
    direction="column"
    v-test="'purchase-credits'"
  >
    <Flex
      direction="column"
      align="center"
      justify="start"
      :gap=".5"
    >
      <img
        :class="$style.img"
        src="/img/admin/sms-credits.svg"
      >
      <BaseHeading>{{ t('sms_credits.not_enough_credits') }}</BaseHeading>
      <BaseText>{{ t('sms_credits.not_enough_credits_description') }}</BaseText>
    </Flex>
    <Flex
      justify="center"
      :gap=".5"
    >
      <div
        v-for="amount in amounts"
        :key="amount"
        @click="chosenAmount = amount"
        :class="$style.cardWrap"
        v-test="'credit-option'"
      >
        <BaseCard
          :gray="chosenAmount === amount"
          :selected="chosenAmount === amount"
        >
          <BaseText bold>
            {{ amount }}
            {{ t('sms_credits.credit', amount) }}
          </BaseText>
          <BaseText>
            {{ filters.currency(amount * getCreditPrice(amount)) }}
          </BaseText>
        </BaseCard>
      </div>
    </Flex>
    <Flex justify="center">
      <BaseText
        v-show="!hasCustomAmount"
        @click="hasCustomAmount = true"
        v-test="'credits-other-amount'"
        color="secondary"
      >
        {{ t('sms_credits.other_amount') }}
      </BaseText>
    </Flex>

    <BaseCard
      v-show="hasCustomAmount"
      gray
    >
      <BaseText bold>
        {{ t('sms_credits.custom_amount') }}
      </BaseText>
      <div :class="$style.customAmount">
        <BaseInput
          v-model="customAmount"
          type="number"
          :minValue="50"
          :label="t('sms_credits.credits_amount')"
          v-test="'credits-custom-amount'"
        />
        <div :class="$style.customAmountRight">
          <div>
            {{ filters.currency(
                customAmount * getCreditPrice(customAmount)
              ) }}
          </div>
        </div>
      </div>
      <BaseText size="s">
        {{ t('sms_credits.minimum_amount', { amount: 50 }) }}
      </BaseText>
    </BaseCard>
  </Flex>
</template>

<script
  setup
  lang="ts"
>
import { useStorage } from '@vueuse/core';
import { useI18n } from 'vue-i18n';
import filters from '@/filters';
import { useCompanyStore } from '@/stores/company';

const { t } = useI18n();

const { company } = useCompanyStore();

const emit = defineEmits(['update:amount', 'onBack']);

const amounts = [100, 500, 1000, 2500];

const chosenAmount = useStorage('sms_credit_amount', amounts[0]);
const customAmount = ref(50);
const hasCustomAmount = ref(false);

const amountToSubmit = computed(() =>
  hasCustomAmount.value ? customAmount.value : chosenAmount.value,
);

watch(
  amountToSubmit,
  (newAmount) => {
    emit('update:amount', newAmount);
  },
  { immediate: true },
);

watch(
  () => chosenAmount.value,
  (newValue) => {
    if (newValue && hasCustomAmount.value) {
      hasCustomAmount.value = false;
    }
  },
);
watch(
  () => hasCustomAmount.value,
  (newValue) => {
    if (newValue) {
      chosenAmount.value = 0;
    }
  },
);

const getCreditPrice = (amount: number) => {
  const creditPrices = company.smsCreditPricing;

  if (amount >= 2500) {
    return creditPrices[2];
  } else if (amount >= 1000) {
    return creditPrices[1];
  } else {
    return creditPrices[0];
  }
};
</script>

<style
  lang="scss"
  module
>
.cardWrap {
  cursor: pointer;
}

.img {
  height: 83px;
}

.customAmount {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: $spacing * 0.5;
}

.customAmountRight {
  text-align: right;
}

</style>
